module.exports = __webpack_public_path__ + "img/icons8-linkedin-circled.ee926207.svg";